import { render, staticRenderFns } from "./OfficialCompensation2.vue?vue&type=template&id=290072e5&scoped=true"
import script from "./OfficialCompensation2.vue?vue&type=script&lang=js"
export * from "./OfficialCompensation2.vue?vue&type=script&lang=js"
import style0 from "./OfficialCompensation2.vue?vue&type=style&index=0&id=290072e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290072e5",
  null
  
)

export default component.exports